import { Component, Input, OnInit } from '@angular/core';
import { geoJSON, icon, latLng, LatLng, LatLngBounds, MapOptions, marker, tileLayer } from 'leaflet';

@Component({
    selector: 'jhi-geojson-map',
    templateUrl: './geojson-map.component.html'
})
export class GeojsonMapComponent implements OnInit {

    options: MapOptions;
    @Input() geojsonList: any[] = [];

    ngOnInit(): void {
        const layers = [];

        layers.push(tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: '...'
        }));

        const allBounds: LatLngBounds[] = [];

        this.geojsonList.forEach((geojson) => {
            const layer = geoJSON(geojson);
            layers.push(layer);

            const bounds = layer.getBounds();
            if (bounds.isValid()) {
                allBounds.push(bounds);

                const boundsCenter = bounds.getCenter();
                layers.push(marker(boundsCenter, {
                    icon: icon({
                        iconSize: [25, 41],
                        iconAnchor: [13, 41],
                        iconUrl: '/ibpworkbench/main/app/content/scss/images/marker-icon.png',
                        shadowUrl: '/ibpworkbench/main/app/content/scss/images/marker-shadow.png'
                    })
                }));
            }
        });

        let center: LatLng = latLng(0, 0);
        let zoom = 2;

        if (allBounds.length > 0) {
            const combinedBounds = new LatLngBounds(allBounds[0].getSouthWest(), allBounds[0].getNorthEast());
            for (let i = 1; i < allBounds.length; i++) {
                combinedBounds.extend(allBounds[i]);
            }
            zoom = 8;
            center = combinedBounds.getCenter();
        }

        this.options = {
            layers,
            center,
            zoom
        };
    }

}
